package ru.it_mozaika.components

import mui.system.sx
import react.FC
import react.Props
import web.cssom.Color

external interface FilterOffButtonProps: Props {
    var handleOnFilterOffClick: () -> Unit
    var propertiesFilter: List<String>
}

val filterOffButton = FC<FilterOffButtonProps>{props ->
    AvatarButton {
        tooltipTitle = "Отменить фильтры"
        mui.icons.material.FilterAltOff {
                sx {
                    if (props.propertiesFilter.isNotEmpty())
                        color = Color("#FF0000")
                }
                onClick = { props.handleOnFilterOffClick() }
            }
        }

}